import React, { Component } from "react";
import requester from "../../lib/requester";
import ReactTable from "react-table";
import "react-table/react-table.css";
import moment from "moment";
import _ from "lodash";
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Summary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(),
      endDate: new Date(),
      dataTable: [],
      baseTable: [],
      search: "",
      user: JSON.parse(window.localStorage.getItem("is_user")),
    };
  }

  componentDidMount = () => {
    let url = "/api/traces/v1/program/summary";
    let param = {
      group: [this.state.user.org_initial],
    };
    this.setState({ loading: true });
    requester.postTraces(url, param, {
      success: function (response) {
        let { data } = response.data;
        data.map((item, index) => {
          item.formatted_start_date = moment(item.start_date).format(
            "DD-MM-YYYY"
          );
          item.formatted_end_date = moment(item.end_date).format("DD-MM-YYYY");
          return item;
        });
        this.setState({ loading: false, dataTable: data, baseTable: data });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };
  renderTable = () => {
    const data = {
      columns: [
        {
          Header: "PROGRAM NO",
          accessor: "program_number",
          filterable: true,
        },
        {
          Header: "REF NO",
          accessor: "ref_number",
          filterable: true,
        },
        {
          Header: "PROGRAM TYPE",
          accessor: "program_name",
          filterable: true,
        },
        {
          Header: "DESCRIPTION",
          accessor: "description",
          filterable: true,
        },
        {
          Header: "PRINCIPAL",
          accessor: "org_name",
          filterable: true,
        },
        {
          Header: "START DATE",
          accessor: "start_date",
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null
                  ? moment(row.value).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          filterable: true,
        },
        {
          Header: "END DATE",
          accessor: "end_date",
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null
                  ? moment(row.value).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          filterable: true,
        },
        // {
        //     Header: 'BUDGET TYPE',
        //     accessor: 'budget_type'
        // },
        {
          Header: "SUBMITTED DATE",
          accessor: "creation_date",
          Cell: (row) => (
            <span>
              <span>
                {row.value !== null
                  ? moment(row.value).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          filterable: true,
        },
        {
          Header: "BUDGET",
          accessor: "budget",
          Cell: (row) => (
            <span>
              {row.value
                ? row.value.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
                : "0"}
            </span>
          ),
          filterable: true,
        },
        {
          Header: "AMOUNT_CLAIM_SUBMIT",
          accessor: "encumbrance",
          className: "text-right",
          // filterable: true,
          Cell: (row) => {
            let value = parseFloat(row.value);
            return (
              <span>
                {value.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            );
          },
          filterable: true,
        },
        {
          Header: "AMOUNT_CLAIM_APPROVED",
          accessor: "actual",
          className: "text-right",
          // filterable: true,
          Cell: (row) => {
            let value = parseFloat(row.value);
            return (
              <span>
                {value.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            );
          },
          filterable: true,
        },
        {
          Header: "TOTAL_AMOUNT_CLAIM",
          accessor: "total",
          className: "text-right",
          // filterable: true,
          Cell: (row) => {
            let value = parseFloat(row.value);
            return (
              <span>
                {value.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </span>
            );
          },
          filterable: true,
        },
        {
          Header: "STATUS",
          accessor: "status",
          filterable: true,
        },
        {
          Header: "",
          accessor: "program_id",
          Cell: (row) => (
            <span>
              <button
                className="btn btn-success btn-sm"
                onClick={() => {
                  this.goDetail(row);
                }}
              >
                View <i className="fas fa-eye" />
              </button>
            </span>
          ),
          filterable: true,
        },
      ],
      rows: this.state.dataTable,
    };
    return (
      <ReactTable
        className="fullWidth"
        data={data.rows}
        columns={data.columns}
        defaultPageSize={10}
        defaultFilterMethod={(filter, row, column) => {
          let columnes = "";
          switch (filter.id) {
            case "start_date":
              columnes = row._original.formatted_start_date;
              break;
            case "end_date":
              columnes = row._original.formatted_end_date;
              break;
            case "creation_date":
              columnes = row._original.formatted_creation_date;
              break;
            default:
              columnes = row[filter.id];
          }

          return columnes
            ? columnes.toLowerCase().includes(filter.value.toLowerCase())
            : "";
        }}
      />
    );
  };

  // exportToExcel = () => {
  //   const dataSet2 = this.state.dataTable;
  //   let filename =
  //     "program-summary-" + moment(new Date()).format("DDMMYYYYHHmmss");

  //   return (
  //     <ExcelFile
  //       filename={filename}
  //       fileExtension="xlsx"
  //       element={
  //         <button className="btn btn-success">
  //           <i className="fas fa-file-excel" />
  //           Export to Excel
  //         </button>
  //       }
  //     >
  //       <ExcelSheet data={dataSet2} name="Leaves">
  //         <ExcelColumn label="PROGRAM NO" value="program_number" />
  //         <ExcelColumn label="REF NO" value="ref_number" />
  //         <ExcelColumn label="PROGRAM TYPE" value="program_name" />
  //         <ExcelColumn label="DESCRIPTION" value="description" />
  //         <ExcelColumn label="PRINCIPALl" value="org_name" />
  //         <ExcelColumn label="START DATE" value="start_date" />
  //         <ExcelColumn label="END DATE" value="end_date" />
  //         {/* <ExcelColumn label="Budget Type" value="budget_type" /> */}
  //         <ExcelColumn label="SUBMITTED DATE" value="creation_date" />
  //         <ExcelColumn label="BUDGET" value="budget" />
  //         <ExcelColumn label="BUDGET" value="budget" />
  //         <ExcelColumn label="AMOUNT_CLAIM_SUBMIT" value="encumbrance" />
  //         <ExcelColumn label="AMOUNT_CLAIM_APPROVED" value="actual" />
  //         <ExcelColumn label="TOTAL_AMOUNT_CLAIM" value="total" />
  //         <ExcelColumn label="STATUS" value="status" />
  //       </ExcelSheet>
  //     </ExcelFile>
  //   );
  // };
  exportToExcel = () => {
    const fileName = `program-summary-${new Date().getTime()}.xlsx`

    const header = {
      "PROGRAM_NO":'',
      "REF_NO":'',
      "PROGRAM_TYPE":'',
      "DESCRIPTION":'',
      "PRINCIPALl":'',
      "START_DATE":'',
      "END_DATE":'',
      "SUBMITTED_DATE":'',
      "BUDGET":'',
      "BUDGET":'',
      "AMOUNT_CLAIM_SUBMIT":'',
      "AMOUNT_CLAIM_APPROVED":'',
      "TOTAL_AMOUNT_CLAIM":'',
      "STATUS":'',
    }
    const mapingDownload = this.state.baseTable && this.state.baseTable.length ? this.state.baseTable.map((value) => {
      return {
        "PROGRAM NO": value.program_number,
        "REF NO": value.ref_number,
        "PROGRAM TYPE": value.program_name,
        "DESCRIPTION": value.description,
        "PRINCIPALl": value.org_name,
        "START DATE": value.start_date,
        "END DATE": value.end_date,
        "SUBMITTED DATE": value.creation_date,
        "BUDGET": value.budget,
        "AMOUNT CLAIM SUBMIT": value.encumbrance,
        "AMOUNT CLAIM APPROVED": value.actual,
        "TOTAL AMOUNT CLAIM": value.total,
        "STATUS": value.status_active,
      }
    }) : header

    requester.downloadXlsxDateFormat(mapingDownload, fileName)
  }

  goDetail = (rows) => {
    let { row } = rows;
    this.props.history.push("/admin/program/summary/" + row.program_id);
  };

  // handleSearch = (e) => {
  //     let value = e.target.value.toLowerCase()
  //     let container = []
  //     _.find(this.state.baseTable, function(o) {
  //         let desc = o.description.toLowerCase()
  //         if(desc.indexOf(value) >= 0){
  //             container.push(o);
  //         }
  //     })
  //     container.map((item, index) => {
  //         item.formatted_start_date = moment(item.start_date).format('DD-MM-YYYY')
  //         item.formatted_end_date = moment(item.end_date).format('DD-MM-YYYY')
  //         return item
  //     })
  //     this.setState({ dataTable: container, search: value })
  // }

  handleSearch = (e) => {
    let value = e.target.value;
    this.setState({ search: value });
    let baseTable = _.filter(this.state.baseTable, function (o) {
      return (
        (o.customer_name
          ? o.customer_name.toLowerCase().includes(value.toLowerCase())
          : "") ||
        o.description.toLowerCase().includes(value.toLowerCase()) ||
        o.org_name.toLowerCase().includes(value.toLowerCase()) ||
        o.program_number.toLowerCase().includes(value.toLowerCase()) ||
        o.ref_number.toLowerCase().includes(value.toLowerCase())
      );
    });
    this.setState({ dataTable: baseTable });
  };

  handleChangeStatus = (e) => {
    let value = e.target.value;
    let url = "/api/traces/v1/program/summary?status=" + value;
    let param = {
      org_id: this.state.user.org_id,
    };
    this.setState({ loading: true, search: "" });
    requester.postTraces(url, param, {
      success: function (response) {
        let { data } = response.data;
        data.map((item, index) => {
          item.formatted_start_date = moment(item.start_date).format(
            "DD-MM-YYYY"
          );
          item.formatted_end_date = moment(item.end_date).format("DD-MM-YYYY");
          return item;
        });
        this.setState({ loading: false, dataTable: data, baseTable: data });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
  };

  badgeClass = (status) => {
    let className = "";
    if (status === "P") {
      className = "badge badge-info";
    } else if (status === "A") {
      className = "badge badge-success";
    } else if (status === "R") {
      className = "badge badge-danger";
    } else {
      className = "badge badge-secondary";
    }
    console.log(className);
    return className;
  };

  mappingStatus = (status) => {
    let mappingStatus = "";
    if (status === "P") {
      mappingStatus = "PROPOSE";
    } else if (status === "A") {
      mappingStatus = "APPROVED";
    } else if (status === "R") {
      mappingStatus = "REJECT";
    }

    return mappingStatus;
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">List</div>
                  <div className="card-body">
                    <div className="row">
                      {/* <div className="col-md-6 float-left">
                                                <div className="row">
                                                    <div className="col-lg-6">
                                                        <select name="" className="form-control" onChange={ this.handleChangeStatus.bind(this) }>
                                                            <option value="">- Select Status -</option>
                                                            <option value="D">DRAFT</option>
                                                            <option value="P">PROPOSE</option>
                                                            <option value="A">APPROVE</option>
                                                            <option value="R">REJECT</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div> */}
                      <div className="col-md-6 float-right">
                        <div className="row">
                          {/* <div className="col-lg-6">
                                                        <input type="text" className="form-control" onChange={ this.handleSearch.bind(this) } placeholder="Search Program..." value={ this.state.search } />
                                                    </div> */}
                          <div className="col-lg-3">
                            {/* <button className="btn btn-success"><i className="fas fa-file-excel" /></button> */}
                            <button className="btn btn-success w-100" onClick={() => this.exportToExcel()}>
                              <i className="fas fa-file-excel" />
                              Export to Excel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="clearfix">&nbsp;</div>
                    <div className="row">
                      <div className="col-lg-12">{this.renderTable()}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <Loader fullPage loading={this.state.loading} /> */}
        </section>
      </div>
    );
  }
}

export default Summary;
